<template>
  <div>
    <div class="quiz border border-info rounded p-2">
      <div
        class="checkQuiz d-flex justify-content-between align-items-baseline mb-2"
      >
        <b-row>
          <b-col sm="12">
            <div class="d-flex">
              <b-form-checkbox
                class="ml-2"
                v-model="quiz.checkQuiz"
              >
                <p class="btn p-0 m-0 text-info">
                  Quiz
                </p>
              </b-form-checkbox>
            </div>
          </b-col>
        </b-row>

        <b-row>
          <b-col sm="6">
            <div v-if="quiz.checkQuiz">
              <label>Score:</label>
              <b-form-input
                v-model="quiz.scoreForQuiz"
                placeholder="Enter Score"
                :class="{
                  'form-group-error':
                    $v.quiz.scoreForQuiz.$error,
                }"
              />
              <span
                class="input-error-message"
                v-if="
                  !$v.quiz.scoreForQuiz.required &&
                  $v.quiz.scoreForQuiz.$dirty
                "
              >
                Score is mandatory!
              </span>
            </div>
          </b-col>

          <b-col sm="6">
            <div v-if="quiz.checkQuiz">
              <label>Best of score:</label>
              <b-form-input
                v-model="quiz.best_of_scores"
                placeholder="Optional"
                type="number"
                min="0"
              />
              <small class="form-text text-muted">
                Number of best scores will be considered
              </small>
            </div>
          </b-col>
        </b-row>
      </div>

      <b-collapse
        v-model="quiz.checkQuiz"
        class="mt-2"
      >
        <div class="mb-2">
          <span class="font-weight-bolder">
            Choose Score Type:
          </span>
        </div>

        <table class="table table-bordered table-striped">
          <thead class="thead-dark">
            <tr>
              <th></th>
              <th>Quiz</th>
              <th v-if="!activity_simple_calculation">
                Percent Weightage
              </th>
            </tr>
          </thead>

          <tbody>
            <tr v-if="quizFromApi.length === 0">
              <td colspan="100" class="text-center text-danger">
                No Data Found!
              </td>
            </tr>

            <tr
              v-for="(quizItem, index) in quizFromApi"
              :key="index"
            >
              <td>
                <b-form-checkbox
                  size="sm"
                  v-model="
                    quizConfigStructure[quizItem.id].checkbox
                  "
                />
              </td>

              <td>{{ quizItem.name }}</td>

              <td
                v-if="!activity_simple_calculation"
                class="text-center"
              >
                <b-form-input
                  v-if="
                    quizConfigStructure[quizItem.id].checkbox
                  "
                  placeholder="Enter Percentage"
                  v-model="
                    quizConfigStructure[quizItem.id].input
                  "
                  @blur="$v.quizConfigStructure.$each.$touch()"
                />

                <div
                  v-if="
                    quizConfigStructure[quizItem.id].checkbox &&
                    $v.quizConfigStructure.$each[quizItem.id]
                      .input.$error
                  "
                  class="text-danger"
                >
                  <span
                    v-if="
                      !$v.quizConfigStructure.$each[quizItem.id]
                        .input.required
                    "
                  >
                    This field is required.
                  </span>
                  <span
                    v-if="
                      !$v.quizConfigStructure.$each[quizItem.id]
                        .input.customValidation
                    "
                  >
                    All values must be equal or sum to 100.
                  </span>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </b-collapse>
    </div>
  </div>
</template>

<script>
import { requiredIf } from "vuelidate/lib/validators";
import moment from "moment";

export default {
  props: ["saved_configs", "courseReport", "activity_simple_calculation"],

  data() {
    return {
      quiz: {
        checkQuiz: false,
        scoreForQuiz: 20,
        best_of_scores: "",
      },
      quizFromApi: [],
      quizConfigStructure: {},
    };
  },

  async created() {
    await this.getQuiz();

    const saved =
      this.saved_configs.activity_catagory_configs.quiz;

    if (saved?.enable) {
      this.quiz = {
        checkQuiz: saved.enable,
        scoreForQuiz: saved.score,
        best_of_scores: saved.best_of_scores,
      };

      Object.keys(saved.resourses.exam || {}).forEach((key) => {
        if (this.quizConfigStructure[key]) {
          this.quizConfigStructure[key].checkbox = true;
          this.quizConfigStructure[key].input =
            saved.resourses.exam[key].persantage_of_wightage;
        }
      });
    }
  },

  validations: {
    quiz: {
      scoreForQuiz: {
        required: requiredIf(function () {
          return this.quiz.checkQuiz;
        }),
      },
    },

    quizConfigStructure: {
      $each: {
        input: {
          required() {
            return Object.values(this.quizConfigStructure).some(
              (c) => c.checkbox
            );
          },

          customValidation() {
            if (
              !this.quiz.checkQuiz ||
              this.activity_simple_calculation
            )
              return true;

            const values = Object.values(
              this.quizConfigStructure
            )
              .filter((c) => c.checkbox)
              .map((c) => Number(c.input));

            if (!values.length) return true;

            const allSame = values.every(
              (v) => v === values[0]
            );
            const sum100 =
              values.reduce((a, b) => a + b, 0) === 100;

            return allSame || sum100;
          },
        },
      },
    },
  },

  methods: {
    async checkValidation() {
      this.$v.$touch();
      return !this.$v.$invalid;
    },

    async getQuiz() {
      const url =
        this.$store.getters.getAPIKey.mainAPI +
        `/course/${this.courseReport.course_id}/exams`;

      const response = await this.$axios.get(url);

      response.data.forEach((item) => {
        if (item.activity_type === "quiz") {
          this.$set(this.quizConfigStructure, item.id, {
            checkbox: false,
            input: "",
          });

          this.quizFromApi.push({
            id: item.id,
            name: item.name,
            maximum_mark: item.maximum_mark,
            date: item.end_at
              ? moment(item.end_at)
              : null,
          });
        }
      });
    },
  },
};
</script>

<style>
.quiz p {
  font-size: 16px;
  font-weight: 600;
}
</style>
